<template>
  <div id="content" class="crpg-o-golf-golf-content category">
    <div id="category_top" class="crpg-o-golf-golf-content__category">
      <div class="top_image">
        <h2>
          {{ $t("golf.titleEn") }}
          <span class="j">{{ $t("golf.titleJa") }}</span>
        </h2>
        <img :src="golfTop" class="sports_main" />
      </div>
    </div>
    <div id="menus" class="crpg-o-golf-golf-content__menus">
      <div class="golf-box">
        <div class="inner-golf">
          <span class="tits">
            {{ content.golfTopTitle }}
          </span>
          <p class="tit">
            {{ content.golfTopContent }}
          </p>
        </div>
        <div class="golf-cover">
          <div class="title">●{{ $t("golf.example") }}</div>
          <ul>
            <li>
              <img
                :src="require(`@/assets/img/${content.contentImage01}`)"
                class="golf_content1"
                :alt="content.contentText01"
              />
              <br />
              <span class="txt">
                {{ content.contentText01 }}
              </span>
            </li>
            <li>
              <img
                :src="require(`@/assets/img/${content.contentImage02}`)"
                class="golf_content2"
                :alt="content.contentText02"
              />
              <br />
              <span class="txt">
                {{ content.contentText01 }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import text from "@/assets/txt/sport.json";

var obj = text;
export default {
  name: "Golf",
  components: {},
  data() {
    return {
      content: obj,
      golfTop: require("@/assets/img/golf_top_1.jpg"),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/golf/golfContent.scss";
</style>
